import { render, staticRenderFns } from "./ScaleImage.vue?vue&type=template&id=b9a4b172"
import script from "./ScaleImage.vue?vue&type=script&lang=js"
export * from "./ScaleImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports